module.exports = __webpack_public_path__ + "img/linkedin.0af0a062.svg";